import { CameraControls } from '@react-three/drei';
import { useThree } from '@react-three/fiber';
import { useEffect } from 'react';

import { CAMERA_POSITION } from '../constants';

/**
 * Sets the initial camera position to the CAMERA_POSITION constant
 * and saves the state of the camera controls
 *
 * This is somehow important once you use CameraControls in your scene (like in the verification step)
 *
 * @returns null
 */
export default function SetInitalCameraPosition() {
  const { controls } = useThree();
  const cameraControls = controls as unknown as CameraControls;

  useEffect(() => {
    if (cameraControls) {
      cameraControls.setLookAt(
        CAMERA_POSITION.x,
        CAMERA_POSITION.y,
        CAMERA_POSITION.z,
        0,
        0.8,
        0,
      );
      cameraControls.saveState();
    }
  }, [cameraControls]);

  return null;
}
